var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"appBox",staticClass:"app-page",attrs:{"id":"app"}},[_c('PageHeader'),_c('router-view',{staticClass:"max-width"}),_c('PageFooter'),_c('scrollTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }